import { themeQuartz } from 'ag-grid-community';

const deepBlue25 = getComputedStyle(document.documentElement).getPropertyValue('--deep-blue-25').trim();

export const customTheme = themeQuartz.withParams({
  rowHoverColor: deepBlue25,
});
